import React from 'react'
import styles from './RegistrationButton.module.scss'

export type StyledRegistrationButtonProps = {
  className?: string
  size: "SMALL" | "LARGE"
}

export const StyledRegistrationButton: React.FC<StyledRegistrationButtonProps> = ({ className, size }) => {
  const containerClass = size === "LARGE" ? styles.largeTextContainer : styles.textContainer;
  return (
    <div className={`${styles.button} ${className ?? ''}`.trim()}>
      <a
        className={`relative flex flex-row flex-wrap text-center justify-center items-center rounded cursor-pointer transition-opacity duration-200 hover:opacity-90 ${containerClass}`}
        href="/signup"
      >
        <span className={`font-normal leading-normal text-white whitespace-nowrap ${styles.firstText}`}>60秒で登録完了</span>
        <span className={`font-medium leading-normal text-white whitespace-nowrap ${styles.lastText}`}>登録する</span>
        <span className={`absolute ${styles.arrowIcon}`}>
          <RightArrowIcon />
        </span>
      </a>
    </div>
  )
}

function RightArrowIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={styles.arrow} viewBox="0 0 7 10" fill="none">
      <path d="M6.5 5L0.5 9.33013L0.5 0.669872L6.5 5Z" fill="white"/>
    </svg>
  )
}
